<template>
  <div class="regionpick" @click.stop>
    <input
      type="text"
      class="input-text"
      v-model="fullName"
      readonly
      placeholder="点击选择地区"
      @click="openCity()"
      :style="'width:' + width"
    />
    <div :class="{floatRight:floatRight}" class="province"  v-if="selectShow">
      <div class="hd clearfix">
        <a
          class="back fr"
          v-if="backShow"
          href="javascript:void(0);"
          @click="cityBack()"
          >上一级</a
        >
        <span class="tit" v-if="levels == '3'"
          >{{ provinceName }}/{{ cityName }}/{{ countryName }}</span
        >
        <span class="tit" v-if="levels == '2'"
          >{{ provinceName }}/{{ cityName }}</span
        >
        <span class="tit" v-if="levels == '1'" >{{ provinceName }}</span>
      </div>
      <ul class="city-list clearfix">
        <li
          v-for="(i, index) in arr"
          :key="index"
          @click="clickCityName(i, index)"
          :style="i.short_name=='国际'?'color:#003366':''"
        >
          {{ i.short_name?i.short_name:i.full_name }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "citys",
  props: {
    levels: {
      //控制层级
      type: String,
      default: "3",
    },
    isHasWorld: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    isAutoWidth: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    fullNameofUrl:{//用于url参数回光返照
       //控制层级
      type: String,
      default: "",
    },
    floatRight:{
      type:Boolean,
       default: function () {
        return false;
      },
    }
  },
  data() {
    return {
      allArr: [],
      selectShow: false,
      arr: [],
      prevArr: [],
      backShow: false, //控制返回按钮显示
      provinceName: "选择省份", //省份名称
      fullProvinceName: "选择省份", //省份全称
      cityName: "选择城市",
      fullCityName: "全国",
      countryName: "选择区县",
      fullCity: "",
      fullName: "",
      fanName: "",
      zxsType: 1,
      curType: 1,
      width: "auto",
      isback: 0,
      timer: "",
    };
  },
  mounted() {
    let that = this;
    document.addEventListener("click", this.closeCity);
    this.fullName = this.curFullName;
    this.fullName=this.fullNameofUrl?this.fullNameofUrl:this.fullName;
  },
  destroyed() {
    document.removeEventListener("click", this.closeCity);
  },

  created() {
    let that = this;
    this.timer = setInterval(() => {
      this.allArr = JSON.parse(sessionStorage.getItem("city2"));
      console.log(this.allArr)
      this.arr = this.allArr;
      if (that.allArr) {
        clearInterval(this.timer);
      }
    }, 100);
     
  },
  methods: {
    
    //关闭
    closeCity() {
      if (this.selectShow) {
        this.selectShow = false;
      }
    },
    // 打开城市
    openCity() {
      let that = this;
      that.isback = 0;
      if (that.selectShow == true) {
        that.selectShow = false;
        that.provinceName = "选择省份";
      } else {
        that.selectShow = true;
        //that.arr = that.allArr.shortProvince;
        if (that.arr == "") { 
          that.arr = that.allArr;
          that.prevArr = that.allArr;
        }
      }
    },
    clickCityMap(name, type) {
      let that = this;

      that.isback = 1;
      if (type == 1) {
        that.arr = that.allArr;
        that.prevArr = that.allArr;
      }
      let i = 0;
      for (let index in that.arr) {
        let ele = that.arr[index];

        if (ele) {
          if (ele.full_name == name) {
            i++;
            that.clickCityName(ele, index);
          }
        }
      }
      if (i == 0) {
        //选择县区时宽度不够，执行设置宽度
        that.setWidth();
      }
    },
    //点击市
    // clickCityName (name,index) {
    //     let that = this;
    //     let provinceName = '';
    //     let fullProvinceName = '';
    //     let cityName = that.cityName;
    //     if(that.provinceName === '选择省份'){//点击的是省份fullCity
    //         that.provinceName = name;
    //         that.fullProvinceName = that.allArr.province[index];
    //         if(that.levels === '1' || name === '全国' || name === '国际'){//只选择省份
    //             that.fanName = that.provinceName;
    //             that.fullName = that.provinceName;
    //             that.selectShow = false;
    //             that.callBack();
    //             that.provinceName = '选择省份';
    //             return;
    //         }
    //         that.backShow = true;
    //         that.arr = that.allArr.city[index-1];
    //         that.fullCity = that.allArr.fullCity[index-1];
    //     }else if(cityName === '选择城市'){//点击的是城市
    //         that.cityName = name;
    //         let names = that.fullCity[index];
    //         that.fullCityName = names;
    //         //that.fullName = that.fullProvinceName + '-' + name;
    //         that.fullName = that.provinceName + '-' + name;
    //         that.fanName = that.provinceName + '-' + names;
    //         that.selectShow = false;
    //             that.callBack();
    //             that.provinceName = '选择省份';
    //             that.cityName = '选择城市';
    //             return;
    //     }
    // },
    clickCityName(item, index) {
      let that = this;
      let teshustr = "北京市天津市上海市重庆";
      if (
        (that.provinceName != "选择省份" &&
          item.full_name != "全省" &&
          item.full_name != "全市" &&
          item.level == 1)  
      ) {
        //选择框和地图点击冲突

        that.backShow = false;
        that.provinceName = "选择省份";
        that.arr = that.prevArr;
      }

      let provinceName = "";
      let fullProvinceName = "";
      let cityName = that.cityName;
      let countryName = that.countryName;
      that.fullName = "";
      that.curType = 1;
      if (that.provinceName === "选择省份") {
        if (item.full_name === "全国") {
          //点击的是全国
          that.provinceName = item.short_name;
          that.fullProvinceName = item.full_name;
          that.selectShow = false;
          that.fullCityName = "";
          that.callBack();
          that.provinceName = "选择省份";
          that.cityName = "选择城市";
          that.countryName = "选择区县";
          return;
        }
        if (item.sons[0].level == 2) {
          item = item.sons[0];
          // console.log(JSON.stringify(item))
        }
        //点击的是省份fullCity
        that.provinceName = item.short_name;
        that.fullProvinceName = item.full_name;

        that.zxsType = item.level;
        that.fanName = that.provinceName;
        that.fullName = that.fullProvinceName;
        if (
          that.levels === "1" ||
          item.full_name === "全国" ||
          item.full_name === "全市" ||
          item.short_name === "国际"
        ) {
          //只选择省份
          that.selectShow = false;
          that.fullCityName = "";
          that.callBack();
          that.provinceName = "选择省份";
          that.cityName = "选择城市";
          that.countryName = "选择区县";
          return;
        }
        that.setWidth();
        that.backShow = true;
        that.prevArr = that.arr;

        that.arr = item.sons;
      } else if (cityName === "选择城市") {
        //点击的是城市
        // if (item.short_name == "台湾" || item.short_name == "香港" || item.short_name == "澳门") {
        //   this.cityBack();
        // }
        that.cityName =
          item.full_name === "全市" || item.full_name === "全省"
            ? item.full_name
            : item.short_name;

        //  that.cityName = item.short_name;
        if (that.zxsType == 2) {
          that.fullCityName = "";
          if (item.full_name == undefined) {
            that.countryName = item.short_name;
          } else {
            that.countryName = item.full_name;
          }
          that.fullName = that.fullProvinceName + "-" + that.countryName;
        } else {
          that.fullCityName = item.full_name;
          that.fullName = that.fullProvinceName + "-" + that.fullCityName;
        }
        that.fanName = that.provinceName + "-" + that.fullCityName;
        let iszxs = 1;
        if (!item.sons) {
          iszxs = 2;
        }
        that.setWidth();
        if (
          that.levels === "2" ||
          item.full_name === "全省" ||
          item.full_name === "全市" ||
          that.zxsType == 2 ||
          iszxs == 2
        ) {
          // if (iszxs == 2) {
          //   that.curType = 5;
          // }
          that.selectShow = false;
          that.callBack();
          // that.provinceName = '选择省份';
          that.cityName = "选择城市";
          that.countryName = "选择区县";
          return;
        }
        that.backShow = true;
        that.prevArr = that.arr;
        that.arr = item.sons;
      } else if (countryName === "选择区县") {
        if (item.full_name === "全市" && that.fullProvinceName == "海南省") {
          that.curType = 5;
        }
        that.countryName = item.full_name;
        that.fullName =
          that.fullProvinceName +
          "-" +
          that.fullCityName +
          "-" +
          item.full_name;
        that.selectShow = false;
        that.setWidth();
        that.callBack();
        // that.provinceName = '选择省份';
        // that.cityName = '选择城市';
        that.countryName = "选择区县";
      }
    },
    // 返回
    cityBack() {
      let that = this;
      if (
        that.allArr == that.prevArr ||
        that.fullCityName == "全省" ||
        that.cityName == "选择城市"
      ) {
        that.backShow = false;
        that.provinceName = "选择省份";
        that.arr = that.prevArr;
      } else {
        that.cityName = "选择城市";
        that.arr = that.prevArr;
        that.prevArr = that.allArr;
      }
    },
    setWidth() {
      let that = this;
      if (that.isAutoWidth) {
        that.width = that.fullName.length * 15 + 30 + "px";
      } else {
        that.width = "auto";
      }
    },
    callBack() {
      let that = this,
        type = 1;
      if (that.curType == 5) {
        type = that.curType;
      } else {
        type = that.zxsType;
      }
      if (that.isback != 1) {
        that.$emit("cityCallback", [
          this.fullProvinceName,
          this.fullCityName,
          this.cityName,
          this.provinceName,
          this.countryName,
          type,
        ]);
      }
    },
  },
};
</script>
<style lang="" scope>
.regionpick {
  display: inline-block;
  position: relative;
}
.regionpick:before {
  content: "";
  width: 14px;
  height: 10px;
  position: absolute;
  top: 10px;
  right: 9px;
  background: url(../../static/images/icons.png) no-repeat 0 -114px;
}
.regionpick .input-text {
  min-width: 150px;
  width: 206px;
  height: 32px;
  padding-right: 30px;
}
.floatRight{
  right: 0 !important;
  left: auto!important;
}
.province {
  position: absolute;
  top: 35px;
  left: 0;
  width: 462px;
  background: var(--header-bg);
  border: 1px solid #ddd;
  z-index: 9;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
}
.province .hd {
  padding: 0 15px;
  line-height: 32px;
  position: relative;
  border-bottom: 1px solid #ddd;
}
.province .hd .back {
  color: #31bcf6;
}
.province .city-list {
  padding: 10px;
}
.province .city-list li {
  float: left;
  min-width: 110px;
  padding: 5px;
  line-height: 24px;
  cursor: pointer;
}
.province .city-list li:hover {
  color: #0095eb;
}
</style>



// WEBPACK FOOTER //
// src/components/city.vue